import { dayjs } from '@2wunder/klarx-tool'
import { Tag } from 'antd'
import { GenericObject, RecordType } from 'app/constants/GlobalTypes'
import { ToolBox } from 'app/lib/hooks/toolBox'
import * as React from 'react'

import { MemberProps } from '../../convention'

const Availability: React.FC<MemberProps<Pick<ICategorySegment, 'earliest_available_date'>>> = ({
  member
}) => {
  const { tComponent } = ToolBox.useString()

  const translate = (id: string, values?: GenericObject<string>) =>
    tComponent({
      componentType: 'data_display',
      componentName: 'list.availability',
      recordType: RecordType.category_segment,
      id,
      values
    })

  if (member?.earliest_available_date) {
    const date = dayjs(member.earliest_available_date)

    return (
      <Tag color="green" className="mr-0">
        {translate('available_from', { date: date.calendar() })}
      </Tag>
    )
  } else {
    return (
      <Tag color="blue" className="mr-0">
        {translate('on_request')}
      </Tag>
    )
  }
}

export default Availability
